export default __webpack_public_path__ + "static/media/title_zh_cn_pc.5d393d96.png";